import PropTypes from "prop-types";
import { Title, Text } from "./NearbyStores.styled";
import NearbyStoresForm from "./nearbyStoresForm/NearbyStoresForm";

export default function NearbyStores({
    subject,
    title,
    description,
    onlyRedeemStores,
    cityOnly
}) {
    return (
        <>
            {title && <Title>{title}</Title>}
            {description && <Text>{description}</Text>}
            <NearbyStoresForm
                subject={subject}
                onlyRedeemStores={onlyRedeemStores}
                cityOnly={cityOnly}
            />
        </>
    );
}

NearbyStores.propTypes = {
    subject: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    onlyRedeemStores: PropTypes.bool,
    cityOnly: PropTypes.bool
};

NearbyStores.defaultProps = {
    subject: undefined,
    title: undefined,
    description: undefined,
    onlyRedeemStores: false,
    cityOnly: false
};
